import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '../../../../product/context/auth/authContext'
//import Popup from '../../../../custom/components/organisms/Popup'
import Popup from '../../../../product/components/organisms/FullScreenPopup'
import AlertContext from '../../../../product/context/alert/alertContext'
import { useFormik } from 'formik'
import PrimaryButton from '../../../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../../product/components/atoms/SecondaryButton'
import CustomInput from '../../../../product/components/atoms/Inputs/CustomInput'
import CustomSelect from '../../../../product/components/atoms/Inputs/CustomSelect'
import { mapData } from '../../../../product/common/components'
import MenuItem from '@mui/material/MenuItem'

import * as Yup from 'yup'
import {
    dateFormatFront,
    dateTimeFormatFunction,
    capitalize,
    currencyFormat,
} from '../../../../custom/common/components'
import InvoiceContext from '../../../../product/context/invoice/invoiceContext'
import ReturnContext from '../../../../product/context/return/returnContext'
import { Divider } from '@mui/material'
import Loaders from '@/product/components/molecules/Loaders'

let REFUND_DETAILS = []

function RefundInvoice(props) {
    const invoiceContext = useContext(InvoiceContext)
    const [allReturned, setAllReturned] = useState(true)
    const { single_invoice, getSingleInvoice, all_invoices } = invoiceContext

    const returnContext = useContext(ReturnContext)
    const {
        refundInvoiceStatus,
        refundInvoiceStatusPartial,
        responseStatus: responseStatusReturn,
    } = returnContext

    const data = props.data
    const toggleFullScreenPopup = props.function

    const { setAlert } = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)
    const [formikError, setFormikError] = useState(0)

    let [invoiceDetails, setInvoiceDetails] = useState({
        invoiceProducts: [],
        cartValues: {},
        appointmentDetail: {},
        locationDetail: {},
        invoiceTransactions: [],
        invoiceAddress: [],
        invoiceUser: [],
    })

    const validationTracking = Yup.object({
        invoice_id: Yup.string().required('Required!'),
        user_id: Yup.string().required('Required!'),
        reason: Yup.string().required('Required!'),
        internal_reason: Yup.string().required('Required!'),
    })

    const addressformik = useFormik({
        initialValues: {
            invoice_id: '',
            user_id: '',
            project_id: [],
            amount: '',
            reason: '',
            internal_reason: '',
            cart: 1,
        },
        validationSchema: validationTracking,
        onSubmit: (values) => {
            console.log('validationTracking', values)
            const isTrue = REFUND_DETAILS.some((det) => det.saved === true)

            if (!isTrue) {
                setAlert('Please select at least one lot to refund', 'error')
                return
            }

            setAllReturned(true)
            setAlert(`Processing your refund`, 'info')
            values.projects = REFUND_DETAILS.filter((det) => det.saved === true)
            values.update_refundable_amount = true
            console.log(values)
            refundInvoiceStatusPartial(values)
            REFUND_DETAILS = []
        },
    })

    useEffect(() => {
        if (data.popup && data.data.id) {
            addressformik.values.invoice_id = data.data.id
            addressformik.values.user_id = data.data.user_id
            addressformik.values.project_id = data?.data?.project_id || []
            setIsLoading(true)
            getSingleInvoice(addressformik.values)
        }
    }, [data])

    const restrictTwoDecimal = (invoiceProducts) =>
        invoiceProducts.map((product) => {
            product.refundable_amount = parseFloat(
                Math.floor(product.refundable_amount * 100) / 100
            ).toFixed(2)

            return product
        })

    useEffect(() => {
        if (
            single_invoice &&
            (data.status === 'edit' || data.status === 'view')
        ) {
            setInvoiceDetails({
                invoiceProducts: single_invoice.invoicerecords.length
                    ? restrictTwoDecimal(single_invoice.invoicerecords)
                    : [],
                cartValues: single_invoice.cartvalues,
                appointmentDetail: single_invoice.appointmentrecord,
                locationDetail: single_invoice.locationrecord,
                invoiceAddress: single_invoice.invoiceaddressrecord,
                invoiceUser: single_invoice.invoiceuserrecord,
                invoiceTransactions: single_invoice.transactionrecords,
            })
            setIsLoading(false)
        }
    }, [single_invoice])

    useEffect(() => {
        invoiceDetails.invoiceProducts.forEach((product) => {
            let isDuplicate = REFUND_DETAILS.some(
                (item) => item.project_id === product.project_id
            )

            if (
                !isDuplicate &&
                !(product.partial_refund === 0 && product.returned === 1)
            ) {
                REFUND_DETAILS.push({
                    project_id: product.project_id,
                    saved: false,
                })
            }

            if (product.returned !== 1 || product.partial_refund !== 0) {
                setAllReturned(false)
            }
        })
    }, [invoiceDetails.invoiceProducts])

    const refundData = {
        formik: addressformik,
        data: [
            // {
            //     label: 'Item Returned',
            //     placeholder: 'Enter Item Returned',
            //     type: 'multiselect',
            //     class: 'col-12',
            //     options: invoiceDetails.invoiceProducts
            //         .filter((cat) => cat.returned !== 1)
            //         .map((maincat) => {
            //             let categoryChanged = {}
            //             categoryChanged.show = maincat.projects_title
            //             categoryChanged.value = maincat.projects_id
            //             return categoryChanged
            //         }),
            //     name: 'project_id',
            // },
            // {
            //     label: 'Enter Amount',
            //     name: 'amount',
            //     type: 'number',
            //     placeholder: `Enter amount`,
            //     class: 'col-sm-6 col-12',
            //     autoFocus: false,
            // },
            {
                label: 'Reason',
                placeholder: 'Enter reason',
                class: 'col-sm-6 col-12',
                type: 'select',
                options: [
                    { value: 'duplicate', show: 'Duplicate' },
                    // { value: 'fraudulent', show: 'Fraudalent' },
                    {
                        value: 'requested_by_customer',
                        show: 'Requested by customer',
                    },
                ],
                name: 'reason',
            },
            {
                label: 'Internal Reason *',
                type: 'text',
                placeholder: 'Enter your Internal Reason',
                class: 'col-sm-6 col-12',
                name: 'internal_reason',
            },
        ],
    }

    useEffect(() => {
        if (responseStatusReturn) {
            if (responseStatusReturn.from === 'refundInvoiceStatus') {
                setAllReturned(false)
                if (responseStatusReturn.status === 'success') {
                    addressformik.resetForm()
                    REFUND_DETAILS = []
                    // props.fetchInvoice()
                    // window.location.reload()
                    toggleFullScreenPopup(false, 'refresh')
                }
            }
        }
    }, [responseStatusReturn])

    const handleSubmit = (e, val) => {
        e.preventDefault()
        console.log(val)
    }

    const submitFn = () => {
        if (addressformik) {
            if (
                addressformik.values.reason == '' ||
                addressformik.values.internal_reason == ''
            ) {
                setAlert(
                    addressformik.values.reason == ''
                        ? 'Reason Field is Required'
                        : 'Internal Reason Field is Required',
                    'error'
                )

                addressformik.handleSubmit()
                window.scrollTo(0, 0)
            } else {
                addressformik.handleSubmit()
            }
        }
    }
    return (
        <Popup
            open={data.popup}
            size="md"
            handleClose={() => {
                REFUND_DETAILS = []
                toggleFullScreenPopup(false)
            }}
            modaltitle="Refund Invoice"
        >
            <div className="trackingInfo">
                {isLoading ? (
                    <div className="text-center">
                        <Loaders name={`home`} isLoading={isLoading} />
                    </div>
                ) : (
                    <>
                        {/* {console.log(trackingInfo, 'tracking info')} */}
                        {invoiceDetails ? (
                            <>
                                {invoiceDetails.invoiceTransactions?.length ? (
                                    <>
                                        <h5 className="invoiceSubTitle">
                                            {'Transaction Details'}
                                        </h5>
                                        <div className="transDet d-flex justify-content-between flex-wrap">
                                            <>
                                                <table className="table table-bordered table-responsive">
                                                    <thead>
                                                        <tr>
                                                            {/* <th scope="col">S.No</th> */}
                                                            <th scope="col">
                                                                {
                                                                    'Transaction ID'
                                                                }
                                                            </th>
                                                            <th scope="col">
                                                                {'Paid on'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Method'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Amount'}
                                                            </th>
                                                            <th scope="col">
                                                                {'Status'}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {invoiceDetails.invoiceTransactions.map(
                                                            (data, index) => (
                                                                <tr key={index}>
                                                                    <td
                                                                        data-title={
                                                                            'Transaction ID'
                                                                        }
                                                                    >
                                                                        {data.trans_id
                                                                            ? `# ${data.trans_id}`
                                                                            : '-'}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            minWidth:
                                                                                '112px',
                                                                        }}
                                                                        data-title={
                                                                            'Paid On'
                                                                        }
                                                                    >
                                                                        {dateTimeFormatFunction(
                                                                            data.created_at
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Card'
                                                                        }
                                                                    >
                                                                        {capitalize(
                                                                            data.payment_method
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Amount'
                                                                        }
                                                                    >
                                                                        {currencyFormat(
                                                                            data.amount
                                                                        )}
                                                                    </td>
                                                                    <td
                                                                        data-title={
                                                                            'Payment Status'
                                                                        }
                                                                        style={{
                                                                            color:
                                                                                data.status ===
                                                                                'success'
                                                                                    ? 'green'
                                                                                    : 'red',
                                                                        }}
                                                                    >
                                                                        {capitalize(
                                                                            data.status
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            </>
                                        </div>
                                    </>
                                ) : null}

                                <div autoComplete="nofill">
                                    <div className="row">
                                        {!allReturned && mapData(refundData)}
                                    </div>
                                    <Divider />
                                    {invoiceDetails.invoiceProducts.map(
                                        (product) => (
                                            <>
                                                {!(
                                                    product.partial_refund ===
                                                        0 &&
                                                    product.returned === 1
                                                ) ? (
                                                    <>
                                                        <div className="listingMiscDetails">
                                                            {product.custom_projects_sku ? (
                                                                <h6 className="lmSku">
                                                                    {
                                                                        product.custom_projects_sku
                                                                    }
                                                                </h6>
                                                            ) : null}

                                                            <h6>
                                                                {
                                                                    product.projects_title
                                                                }
                                                            </h6>
                                                            <h6>
                                                                Maximum
                                                                refundable
                                                                amount for this
                                                                item is : $
                                                                {
                                                                    product.refundable_amount
                                                                }
                                                            </h6>
                                                        </div>
                                                        <FormikRow
                                                            product={product}
                                                            key={product.id}
                                                        />
                                                    </>
                                                ) : (
                                                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                        <h5>
                                                            {
                                                                product.projects_title
                                                            }
                                                        </h5>
                                                        <h6 className="mb-4">
                                                            This item has been
                                                            fully refunded.
                                                        </h6>
                                                    </div>
                                                )}
                                            </>
                                        )
                                    )}
                                    <div className="actionButton d-flex justify-content-center align-items-center flex-wrap">
                                        <SecondaryButton
                                            label="Cancel"
                                            btnSize="mr-3"
                                            onClick={() =>
                                                toggleFullScreenPopup(false)
                                            }
                                        />
                                        <PrimaryButton
                                            onClick={submitFn}
                                            label="Submit"
                                            disabled={allReturned}
                                        />
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div> Invoice Details Not Fetched </div>
                        )}
                    </>
                )}
            </div>
        </Popup>
    )
}

const getProductData = (product) => ({
    ...product,
    return_type: product.partial_refund ? 'partial' : 'full',
})

const FormikRow = ({ product }) => {
    // console.log('DATA', getProductData(product))
    const [details, setDetails] = useState(getProductData(product))
    const [disable, setDisable] = useState(false)
    const [amountError, setAmountError] = useState(null)

    const itemLineValidation = Yup.object({
        refundable_amount: Yup.number()
            .max(
                details.refundable_amount,
                `Amount should not be more than ${details.refundable_amount}`
            )
            .required('Required!'),
    })

    const formik = useFormik({
        initialValues: getProductData(product),
        validationSchema: itemLineValidation,
        validate: (values) => {
            if (
                formik.values.return_type === 'partial' &&
                values.refundable_amount > details.refundable_amount
            ) {
                setAmountError(
                    `Refundable amount should not be more than $${parseFloat(
                        details.refundable_amount
                    )}`
                )
            } else if (parseFloat(values.refundable_amount) <= 0) {
                setAmountError(`Refundable amount should be greater than 0`)
            } else setAmountError(null)
        },
        onSubmit: (values) => {
            if (amountError) {
                return true
            }
            setDisable((disable) => !disable)
            updateRefundDetails(REFUND_DETAILS, values.project_id, {
                project_id: values.project_id,
                return_type: values.return_type,
                total_amount: values.amount,
                refund_amount: parseFloat(values.refundable_amount),
                saved: true,
            })

            console.log(REFUND_DETAILS)
        },
    })

    const updateRefundDetails = (array, projectId, newObject) => {
        for (let i = 0; i < array.length; i++) {
            if (array[i].project_id === projectId) {
                array[i] = newObject
                break
            }
        }
    }

    const toggleEditMode = () => {
        setDisable((disable) => !disable)
        updateRefundDetails(REFUND_DETAILS, details.project_id, {
            project_id: details.project_id,
            saved: false,
        })
    }

    useEffect(() => {
        setAmountError(null)
        if (formik.values.return_type === 'partial') {
            formik.values.amount = ''
            formik.values.total_amount = ''
        } else if (formik.values.return_type === 'full') {
            formik.values.amount = details.amount
            formik.values.total_amount = details.total_amount
            formik.values.refundable_amount = parseFloat(
                details.refundable_amount
            )
        }
    }, [formik.values.return_type])

    useEffect(() => {
        if (formik.values.return_type === 'partial') {
            formik.values.refundable_amount = parseFloat(
                parseFloat(formik.values.amount)
            )
        }
    }, [formik.values.amount])

    const options = [
        {
            value: 'full',
            show: `Full ${formik.values.partial_refund ? '(Remaining)' : ''}`,
        },
        {
            value: 'partial',
            show: 'Partial',
        },
    ]

    return (
        <div className="refundModal">
            <div className="row">
                <div className="col flex-basis-sm-auto">
                    <CustomSelect
                        label={`Return Type`}
                        name={`return_type`}
                        disabled={disable}
                        value={formik.values.return_type}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        options={options}
                    ></CustomSelect>
                </div>
                <div className="col flex-basis-sm-auto">
                    <CustomInput
                        label={`Refund Amount`}
                        type="number"
                        name={`amount`}
                        disabled={
                            formik.values.return_type === 'full'
                                ? true
                                : false || disable
                        }
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={
                            formik.values.return_type === 'full'
                                ? parseFloat(
                                      formik.values.refundable_amount
                                  ).toFixed(2)
                                : ''
                        }
                        className="col-sm-6 col-12"
                    />
                </div>
                {/* <div className="col flex-basis-sm-auto">
                    <CustomInput
                        label={`Tax Amount ${formik.values.tax_percent}`}
                        type="number"
                        name={`total_tax`}
                        disabled={true}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={parseFloat(formik.values.total_tax)}
                        className="col-sm-6 col-12"
                    />
                </div> */}
                <div className="col flex-basis-sm-auto">
                    <CustomInput
                        label={`Total Refund Amount`}
                        type="number"
                        name={`refundable_amount`}
                        disabled={true}
                        error={amountError}
                        helperText={amountError}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={parseFloat(
                            formik.values.refundable_amount
                        ).toFixed(2)}
                        className="col-sm-6 col-12"
                        hidden={true}
                    />
                </div>
                <div className="col flex-basis-md-auto">
                    <div className="actionButton invce d-flex justify-content-end align-items-center flex-wrap mb-4 w-100">
                        <SecondaryButton
                            onClick={toggleEditMode}
                            label="Edit"
                            btnSize="mr-3 w-25"
                            disabled={!disable}
                        />
                        <PrimaryButton
                            type="submit"
                            label="Save"
                            btnSize="w-25"
                            disabled={disable}
                            onClick={formik.handleSubmit}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RefundInvoice
